import { getSnippetRoleTraits, getSnippetTraits } from './snippetTraits';
import { snippetRef } from './consts';
import { parameterize } from '../../apiUtils';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const { projectId, labelSnippet, version } = opts;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  domc.addType(snippetRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          snippetUuid: '',
          showHtmlContent: true,
          icon: '<i class="wb webconnect-alarm"></i>',
          'custom-name': 'Snippet',
          projectId: projectId,
          version: version,
          script: function () {
            const snippetUuid = '{[ snippetUuid ]}';
            const projectId = '{[ projectId ]}';
            const version = '{[ version ]}';
            let enableRoleHandling = '{[ enableRoleHandling ]}';
            let showHtmlContent = '{[ showHtmlContent ]}';
            if (snippetUuid && snippetUuid.length > 0) {
              const headers = {
                'Content-Type': 'application/json',
                'x-project-id': projectId,
              };
              let snippetEl = this;
              const identifyType = snippetEl.getAttribute('data-gjs-type');
              const newFlow = snippetEl.hasAttribute('data-snippet-new');
              console.log(
                '🚀 ~ Snippet Script ~ identifyType:',
                identifyType,
                '~ newFlow:',
                newFlow,
                '~ snippetEl:',
                snippetEl,
              );
              let showContent = false;
              let serverUrl = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/`;
              if (!identifyType) {
                console.log('🚀 ~ Snippet Script ~ changing server url...');
                serverUrl = getBackendServerUrl();
                console.log('🚀 ~ Snippet Script ~ serverUrl new:', serverUrl);
                showContent = true;
              }
              let snippetUUID = snippetUuid;
              enableRoleHandling = enableRoleHandling.trim();
              console.log(
                '🚀 ~ Snippet Script ~ snippet UUID:',
                snippetUUID,
                '~ enable role handling value:',
                enableRoleHandling,
                '~ should enable role handling:',
                !!enableRoleHandling,
                '~ serverUrl:',
                serverUrl,
                '~ showContent:',
                showContent,
              );
              if (enableRoleHandling === true || enableRoleHandling === 'true') {
                if (newFlow) {
                  // New flow for role handling
                  if (!identifyType) {
                    console.log('🚀 ~ Snippet Script ~ using new flow for role handling...');
                    if (typeof processRoleBasedSnippet !== 'undefined') {
                      const { newSnippetUUID, newSnippetEl } = processRoleBasedSnippet(
                        snippetUUID,
                        snippetEl,
                      );
                      snippetUUID = newSnippetUUID;
                      snippetEl = newSnippetEl;
                      console.log(
                        '🚀 ~ Snippet Script: new flow ~ snippetUUID:',
                        snippetUUID,
                        '~ snippetEl:',
                        snippetEl,
                      );
                    }
                  }
                } else {
                  // Fallback for old snippets
                  console.log('🚀 ~ Snippet Script ~ using old flow for role handling...');
                  if (!identifyType) {
                    let userObjString = localStorage.getItem('user');
                    let user = '';
                    if (userObjString && userObjString !== 'undefined') {
                      user = parseLSJSONStrToJSON('user');
                      console.log('*** 🚀 ~ Snippet Script: old flow ~ user:', user);
                      if (user) {
                        const { userRoles } = user;
                        const loggedInUserRole =
                          userRoles && userRoles.length === 1 ? userRoles[0] : '';
                        const roleParameterize = loggedInUserRole
                          .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                            return word.toLowerCase();
                          })
                          .trim()
                          .replace(/\s+/g, '-')
                          .replace(/[^a-zA-Z0-9]+/g, '-');
                        const snippetElAttrs = snippetEl.attributes;
                        let roleSnippetUuidMap = [];
                        Array.from(snippetElAttrs).forEach(({ name, value }) => {
                          if (name.startsWith('data-rolesnippetuuid-')) {
                            if (value) {
                              const attrRole = name.split('data-rolesnippetuuid-')[1];
                              roleSnippetUuidMap.push({ role: attrRole, snippet: value });
                            } else {
                              snippetEl.removeAttribute(name);
                            }
                          }
                        });

                        console.log(
                          '🚀 ~ Snippet Script: old flow ~ roleSnippetUuidMap:',
                          roleSnippetUuidMap,
                        );
                        const filteredRoleSnippet = roleSnippetUuidMap.find(
                          (roleSnippet) => roleSnippet.role === roleParameterize,
                        );
                        console.log(
                          '🚀 ~ Snippet Script: old flow ~ filteredRoleSnippet:',
                          filteredRoleSnippet,
                        );
                        const roleSnippetUuid = filteredRoleSnippet
                          ? filteredRoleSnippet.snippet
                          : '';
                        if (roleSnippetUuid) {
                          snippetUUID = roleSnippetUuid;
                          console.log(
                            '🚀 ~ Snippet Script: old flow ~ snippetUUID #2:',
                            snippetUUID,
                          );
                        }
                      }
                    }
                  }
                }
              }
              let url = `${serverUrl}projects/${projectId}/snippet-templates/${snippetUUID}`;
              const extra = {
                method: 'GET',
                headers,
              };
              showHtmlContent = showHtmlContent.trim();
              if (showContent || showHtmlContent === true || showHtmlContent === 'true') {
                const lang = localStorage.getItem('lang');
                if (lang) {
                  url = `${url}/content?lang=${lang}`;
                } else {
                  url = `${url}/content`;
                }
                console.log('🚀 ~ Snippet Script ~ url show full content:', url);
                fetch(url, extra)
                  .then((response) => {
                    return response.json();
                  })
                  .then((res) => {
                    let snippetHtml =
                      res['nocode-html'] && !identifyType
                        ? replaceNbsps(res['nocode-html'])
                        : res['nocode-html'];
                    snippetEl.innerHTML = snippetHtml + `<style>${res['nocode-css']}</style>`;
                    if (newFlow) {
                      // New flow for snippets
                      if (!identifyType) {
                        console.log('🚀 ~ Snippet Script ~ using new flow...');
                        const snippetOptions = {
                          snippetUuid: snippetUuid,
                          projectId: projectId,
                          version: version,
                          enableRoleHandling: enableRoleHandling,
                          showHtmlContent: showHtmlContent,
                          snippetEl: snippetEl,
                          snippetContent: res,
                        };
                        if (typeof loadSnippetContent !== 'undefined') {
                          loadSnippetContent(this, snippetOptions);
                        }
                      }
                    } else {
                      // Fallback for old snippets
                      console.log('🚀 ~ Snippet Script ~ using old flow...');
                      if (!identifyType) {
                        let isModal = false;
                        const isModalContainer = this && this.closest('[id^=modal-container]');
                        isModal = isModalContainer ? true : false;
                        console.log('🚀 ~ Snippet Script: old flow ~ isModal:', isModal);
                        const dcMetaExists = document.getElementById('dcmeta') !== null;
                        console.log('🚀 ~ Snippet Script: old flow ~ dcMetaExists:', dcMetaExists);
                        if (!dcMetaExists) {
                          addEventsScriptForSnippet(res, snippetEl);
                        }
                        loadHyperLinkFromEntity('[data-snippet-id] [data-path-collection-name]');
                        loadSessionDataIntoElements(isModal, '[data-snippet-id] [data-session]');
                        loadSessionTenantDataIntoElements(
                          isModal,
                          '[data-snippet-id] [data-session-tenant]',
                        );
                        const typesenseComponents = snippetEl.querySelectorAll(
                          '[data-typesense-search-component]',
                        );
                        if (typesenseComponents && typesenseComponents.length) {
                          typesenseComponents.forEach((component) => {
                            renderTypesenseSearch(component);
                          });
                        }
                        const notesWrapperComponents = snippetEl.querySelectorAll('[data-notes-wrapper]');
  console.log("🚀 ~ loadSnippetContent ~ notesWrapperComponents:", notesWrapperComponents);
  
  if(notesWrapperComponents && notesWrapperComponents.length){
    notesWrapperComponents.forEach((component)=>{
     loadNotesData(component);
    })
  }
                        let visibilityElements = snippetEl.querySelectorAll('[data-vis-condition]');
                        console.log(
                          '🚀 ~ %cSnippet Script: old flow ~ visibilityElements:',
                          'color:yellow;font-weight:bold',
                          visibilityElements,
                        );

                        if (visibilityElements && visibilityElements.length) {
                          console.log(
                            '🚀 ~ %cSnippet Script: old flow ~ Processing Component Visibility...',
                            'color:yellow',
                          );
                          let compVisibilityDataJson = {
                            itemData: {},
                          };

                          visibilityElements.forEach((visibilityElem) => {
                            const visConditionJson = parseVisibilityCondition(visibilityElem);
                            const visWhenCollectionFrom = visConditionJson['visWhenCollectionFrom'];
                            const visWhenBsl = visConditionJson['visWhenBsl'];
                            const visWhenBslKey = visConditionJson['visWhenBslKey'];
                            console.log(
                              '🚀 ~ Snippet Script: old flow ~ visibilityElements.forEach ~ visWhenCollectionFrom:',
                              visWhenCollectionFrom,
                              'visWhenBsl:',
                              visWhenBsl,
                              'visWhenBslKey:',
                              visWhenBslKey,
                            );
                            if (visWhenCollectionFrom === 'BROWSER_STORAGE') {
                              // Get Browser Storage Data Object
                              let browserData = {};
                              switch (visWhenBsl) {
                                case 'SESSION_STORAGE':
                                  browserData = getBrowserSessionStorageData();
                                  break;
                                case 'LOCAL_STORAGE':
                                  browserData = getBrowserLocalStorageData();
                                  break;
                                case 'COOKIES':
                                  browserData = getBrowserCookieData();
                                  break;
                                default:
                                  break;
                              }

                              console.log(
                                '🚀 ~ Snippet Script: old flow ~ visibilityElements.forEach ~ browserData:',
                                browserData,
                              );

                              let compVisibilityDataJson = {
                                itemData: browserData,
                              };
                              processComponentVisibilityCondition(
                                visibilityElem,
                                compVisibilityDataJson,
                              );
                            } else {
                              processComponentVisibilityCondition(
                                visibilityElem,
                                compVisibilityDataJson,
                              );
                            }
                          });
                        }
                      }
                    }
                  });
              } else {
                console.log('🚀 ~ Snippet Script ~ url only show name:', url);
                fetch(url, extra)
                  .then((response) => {
                    return response.json();
                  })
                  .then((res) => {
                    snippetEl.innerHTML = res['name'];
                  });
              }
            }
          },
        },
        init() {
          getSnippetTraits(projectId, version, labelSnippet).then((res) => {
            if (res) {
              this.addTrait(res, { at: 0 });
              this.addTrait(
                {
                  type: 'checkbox',
                  label: 'Handle via User Role',
                  name: 'enableRoleHandling',
                  changeProp: 1,
                },
                { at: 1 },
              );
              this.addTrait(
                {
                  type: 'checkbox',
                  label: 'Show Snippet Content',
                  name: 'showHtmlContent',
                  changeProp: 1,
                },
                { at: 2 },
              );

              const enableRoleHandling = this.get('enableRoleHandling');
              if (enableRoleHandling) {
                this.handleEnableRoleHandlingChange();
              }
            }
          });

          this.on('change:snippetUuid', this.handleCollectionChange);
          this.on('change:enableRoleHandling', this.handleEnableRoleHandlingChange);
        },
        async handleCollectionChange() {
          const snippetUuid = this.get('snippetUuid');
          this.setAttributes({
            'data-snippet-id': snippetUuid,
            'data-snippet-new': true,
          });
        },
        async handleEnableRoleHandlingChange() {
          const snippetUuid = this.get('snippetUuid');
          const enableRoleHandling = this.get('enableRoleHandling');
          this.setAttributes({
            'data-role-handling': enableRoleHandling,
          });

          if (enableRoleHandling) {
            getSnippetRoleTraits(projectId, version, labelSnippet).then((response) => {
              if (response) {
                response.forEach((item, key) => {
                  const { userRole, snippetOptions } = item ? item : '';
                  const { name, uuid } = userRole ? userRole : '';
                  const nameParamCase = parameterize(name);
                  if (name && uuid) {
                    this.addTrait(
                      {
                        type: 'select',
                        label: name,
                        name: `roleSnippetUuid-${nameParamCase}`,
                        changeProp: 1,
                        options: snippetOptions,
                      },
                      { at: key + 2 },
                    );
                    const roleSnippetUuid = this.get(`roleSnippetUuid-${nameParamCase}`);
                    if (roleSnippetUuid) {
                      this.addAttributes({
                        [`data-roleSnippetUuid-${nameParamCase}`]: roleSnippetUuid,
                      });
                    }
                    this.on(
                      `change:roleSnippetUuid-${nameParamCase}`,
                      this.handleRoleSnippetChange,
                    );
                  }
                });
              }
            });
          } else {
            let traitsToRemove = [];
            const traits = this.get('traits');
            traits.forEach((trait) => {
              if (trait.props().name.startsWith('roleSnippetUuid-')) {
                traitsToRemove.push(trait.props().name);
              }
            });
            const attrs = this.getAttributes();
            traitsToRemove.forEach((traitName) => {
              delete attrs[traitName.toLowerCase()];
              this.removeTrait(traitName);
            });
            this.setAttributes(attrs);
          }
        },
        async handleRoleSnippetChange() {
          Object.keys(this.changed).forEach((key) => {
            const snippetUuid = this.changed[key];
            this.addAttributes({
              [key]: snippetUuid,
              [`data-${key}`]: snippetUuid,
            });
          });
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === snippetRef) {
            return {
              type: snippetRef,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:snippetUuid', this.updateScript);
        this.listenTo(model, 'change:showHtmlContent', this.updateScript);
      },
    }),
  });
}
